import { Helmet } from 'react-helmet';
import StepWizard from '../../../commons/StepWizard/StepWizard';
import { loginCommercialSteps } from './LoginPUB.data';

export default () => {
  return (
    <>
      <Helmet>
        <title>Connexion acheteurs publics</title>
      </Helmet>
      <StepWizard steps={loginCommercialSteps} />
    </>
  );
};
